import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { logEventInGTAG } from 'src/app/project/services/analytics/google-analytics';
import {
  EGoogleEventCategory,
  EGoogleEventSidePanel,
} from 'src/app/project/services/analytics/google-analytics.consts';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { TSidePanel } from '../../side-panel.model';
import { SidePanelService } from '../../side-panel.service';
import { PreviousPageService } from 'src/app/core/services/previous-page.service';

@Component({
    selector: 'pp-side-panel-reminders',
    templateUrl: './side-panel-reminders.component.html',
    styleUrls: ['./side-panel-reminders.component.scss'],
    standalone: false
})
export class SidePanelRemindersComponent {
  @Input() ppRouterPath: string;
  @Input() ppActiveWorkspaceId: string;
  @Input() ppDisabled: boolean;

  sidePanel: TSidePanel = this.sidePanelService.getSidePanel();
  EIconPath = EIconPath;

  constructor(
    private sidePanelService: SidePanelService,
    private router: Router,
    private previousPageService: PreviousPageService,
  ) {}

  goToReminders(): void {
    if (this.ppActiveWorkspaceId) {
      const routerLink = '/reminders';

      this.sidePanel.notificationsExpanded = false;

      logEventInGTAG(EGoogleEventSidePanel.SIDE_PANEL_REMINDERS, {
        source: EGoogleEventCategory.SIDE_PANEL,
      });

      this.previousPageService.setPreviousRemindersUrl(this.router.url);

      this.router.navigate([routerLink], {
        queryParams: {
          mode: 'month',
        },
      });
    }
  }
}
